import React from 'react';
import styled from 'styled-components';
import { Spinner } from '@/Spinner';

export interface BackdropSpinnerProps {
  loading?: boolean;
  backgroundColor?: string;
  blurAmount?: number;
  borderRadius?: string;
  spinnerSize?: number;
  marginTop?: string;
}

export function BackdropSpinner({
  loading,
  backgroundColor,
  blurAmount,
  borderRadius,
  spinnerSize,
  marginTop,
}: BackdropSpinnerProps) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {loading && (
        <Backdrop
          onClick={(e) => e.stopPropagation()}
          background={backgroundColor || `rgba(0,0,0,0.1)`}
          blurAmount={typeof blurAmount === `undefined` ? 12 : blurAmount}
          borderRadius={borderRadius}
          marginTop={marginTop || `0`}
        >
          <Spinner mt="0" size={spinnerSize} />
        </Backdrop>
      )}
    </>
  );
}

const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.background};
  margin-top: ${(props) => props.marginTop};
  border-radius: ${(props) => props.borderRadius ?? `0`};
  backdrop-filter: blur(${(props) => props.blurAmount}px);
  z-index: 100000;

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  animation: fade-in 0.2s ease;
`;
